import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VSnackbar,{attrs:{"color":_vm.alertType,"multi-line":_vm.mode === 'multi-line',"timeout":_vm.timeout,"top":"top"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }